import { useState, useEffect } from 'react'

export const useScrollSpy = (sections) => {
  const [activeSection, setActiveSection] = useState(sections[0]?.name || 'Christian Fiebig')

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const windowHeight = window.innerHeight

      if (scrollY < 100) {
        setActiveSection(sections[0]?.name || 'Christian Fiebig')
        return
      }

      let maxVisibility = 0
      let activeId = sections[0]?.id

      sections.forEach(({ id }) => {
        const element = document.getElementById(id) || document.querySelector(`[data-section="${id}"]`)
        if (!element) return

        const rect = element.getBoundingClientRect()
        const elementTop = rect.top + scrollY
        const elementBottom = rect.bottom + scrollY

        const visibleTop = Math.max(0, scrollY - elementTop + windowHeight * 0.2)
        const visibleBottom = Math.max(0, elementBottom - scrollY - windowHeight * 0.8)
        const visibleHeight = Math.min(rect.height, visibleTop, visibleBottom)
        const visibility = rect.height > 0 ? visibleHeight / rect.height : 0

        if (visibility > maxVisibility) {
          maxVisibility = visibility
          activeId = id
        }
      })

      if (activeId) {
        const sectionName = sections.find((s) => s.id === activeId)?.name || sections[0]?.name
        setActiveSection(sectionName)
      }
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [sections])

  return activeSection
}
